/**
 * Not Found Page
 *
 * Show an error message, when no Route matched
 */

import React from "react";
import {IndexLink} from "react-router";

const NotFoundPage = () => {
  return (
    <div className="erg-margin-15">
      <h1 className="erg-margin-bottom-0 text-danger">
        <span className="fa fa-ban" /> Page Not Found
      </h1>
      <p className="erg-margin-top-15 text-danger">
        Something went wrong and we not found page by your request.
      </p>
      <p className="erg-margin-top-15 small">
        <IndexLink to="/">Back to home page</IndexLink>
      </p>
    </div>
  );
};

export default NotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/NotFoundPage.js
 **/